import React, { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";

// On small screens, when a text field is focused (the on-screen keyboard opens),
// hide the bottom nav bar and show a "Hide keyboard" pill that actually dismisses it.
const EDITABLE = ["INPUT", "TEXTAREA"];
function isEditable(el) {
  if (!el) return false;
  if (el.isContentEditable) return true;
  if (!EDITABLE.includes(el.tagName)) return false;
  if (el.tagName === "INPUT") {
    const t = (el.getAttribute("type") || "text").toLowerCase();
    if (["checkbox", "radio", "range", "button", "submit", "file", "color"].includes(t)) return false;
  }
  return true;
}

export default function MobileKeyboardHelper() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let raf = null;
    const isMobile = () => window.matchMedia("(max-width: 1023px)").matches;
    const apply = (next) => {
      setOpen(next);
      document.body.classList.toggle("kbd-open", next);
    };
    const onFocusIn = (e) => {
      if (isMobile() && isEditable(e.target)) { if (raf) clearTimeout(raf); apply(true); }
    };
    const onFocusOut = () => {
      // debounce so moving between fields doesn't flicker the nav
      if (raf) clearTimeout(raf);
      raf = setTimeout(() => { if (!isEditable(document.activeElement)) apply(false); }, 120);
    };
    document.addEventListener("focusin", onFocusIn);
    document.addEventListener("focusout", onFocusOut);
    return () => {
      document.removeEventListener("focusin", onFocusIn);
      document.removeEventListener("focusout", onFocusOut);
      if (raf) clearTimeout(raf);
      document.body.classList.remove("kbd-open");
    };
  }, []);

  const hide = (e) => {
    e.preventDefault();
    const el = document.activeElement;
    if (el && typeof el.blur === "function") el.blur();
    setOpen(false);
    document.body.classList.remove("kbd-open");
  };

  if (!open) return null;
  return (
    <button
      type="button"
      data-testid="hide-keyboard-btn"
      onMouseDown={hide}
      onTouchStart={hide}
      className="lg:hidden fixed z-[70] right-3 bottom-3 flex items-center gap-1.5 rounded-full bg-slate-900/95 border border-white/15 text-slate-100 text-xs font-semibold px-3.5 py-2 shadow-[0_8px_30px_rgba(0,0,0,0.6)] backdrop-blur-xl active:scale-95 transition-transform"
      style={{ bottom: "calc(env(safe-area-inset-bottom, 0px) + 12px)" }}
    >
      <ChevronDown className="w-4 h-4" /> Hide keyboard
    </button>
  );
}
